import { Box, Button, Dialog, DialogContent, TextField, Typography } from "@mui/material"
import { branchApiNm } from "branch/constant/branchApiNm"
import { BoxFC, BoxFR } from "components/BoxCustom"
import PaperComponent from "components/PaperComponent"
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import dayjs from "dayjs"
import React, { useCallback, useContext, useEffect, useState } from "react"
import { numberFormat } from "utils"
import { salaryDriverColNm } from "./constant"
import { bahtProps } from "utils/bahtProps"
import { blue, green, grey, red } from "@mui/material/colors"
import { initSalaryDialogDetail } from "./initData"
import { addSumRow, getSumColorClassName, sxSumColorClass } from "utils/highlightSumColor"
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand"
import { salaryDriverDetailColumns } from "./columns"
import { PrintRounded } from "resource/muiImport"
import { printDriverSalary } from "branch/functions/printDriverSalary"

// const watchCols = [87]

const DriverSalaryDetail = ({ drvId, salDte, dialogOpen, setDialogOpen }) => {

  const { ax, msData } = useContext(GlobalStateContext)
  const [dialogData, setDialogData] = useState({ ...initSalaryDialogDetail })
  const [dataTable, setDataTable] = useState([{ id: 0 }])

  const textFieldProps = useCallback((name) => ({
    size: "small",
    label: salaryDriverColNm[name],
    value: numberFormat(+dialogData[name]),
    ...bahtProps,
    sx: { width: 200 },
  }), [dialogData])

  const handlePrint = useCallback(() => {
    const printData = dataTable.map(row => ({
      ...row,
      OthAmnt: +row.OthAmnt + +row.E7,
      OthDscp: `${row.E7 ? "ค่า x-ray" : ""}${row.E7 && row.OthDscp ? ", " : ""}${row.OthDscp || ""}`
    }))
    printDriverSalary({ dialogData, dataTable: printData, msData })
  }, [msData, dialogData, dataTable])

  // const salaryDriverDetailColumnsMemo = useMemo(() => {
  //   const newCols = []
  //   for (const id of watchCols) {
  //     newCols.push({
  //       field: `E${id}`,
  //       headerName: msData.expObj[id]?.ExpNm,
  //       width: 100,
  //       align: 'right',
  //       editable: true,
  //       valueFormatter: ({ value }) => value ? numberFormat(value) : '-'
  //     })
  //   }
  //   return [
  //     ...salaryDriverDetailColumns
  //   ]
  // }, [msData.expObj])

  useEffect(() => {
    if (dialogOpen) {
      const postData = {
        DrvId: drvId,
        SalDte: dayjs(salDte).format("YYYY-MM-01")
      }

      const addExpData = (obj, data) => {
        if (data.ExpId === 87) {
          obj.TripAmnt = +data.PayAmnt
          if (data.Dscp) {
            obj.OthDscpSet.add(data.Dscp)
          }
        } else {
          console.log("else data.ExpId::", data.ExpId)
          obj.OthAmnt = +data.PayAmnt
          obj.OthDscpSet.add(`${data.ExpNm}${data.Dscp ? `(${data.Dscp})` : ""}`)
        }
        obj.OthDscp = [...obj.OthDscpSet].join(', ')
        obj.ExpTotal += +data.PayAmnt
      }
      ax.post(branchApiNm.getSalaryDetail, postData).then(value => {
        if (value.data) {
          const results = []
          let no = 0;
          let sumExpTotal = 0;
          const ots = value.data.OTs.map(ot => ({ ...ot }))

          for (const data of value.data.PCTrns) {
            const found = results.find(row => row.JobOrdId === data.JobOrdId)
            if (!found) {
              no++;
              const newData = {
                id: data.PCTrnsId,
                No: no,
                TripAmnt: 0,
                OthAmnt: 0,
                OthDscpSet: new Set(),
                ExpTotal: 0,
                ...data,
              }
              addExpData(newData, data)
              results.push(newData)
            } else {
              addExpData(found, data)
            }
            sumExpTotal += +data.PayAmnt
          }

          for (const row of results) {
            const foundLashing = ots.find(ot => ot.JobOrdId === row.JobOrdId && ot.ExpId === 86)
            const foundOT = ots.find(ot => ot.JobOrdId === row.JobOrdId && ot.ExpId === 88)
            if (foundOT) {
              console.log("foundOT row ::", foundOT, row)
            }
            row.E86 = foundLashing ? foundLashing.PayAmnt : 0
            row.E88 = foundOT ? foundOT.PayAmnt : 0
            row.ExpTotal += +(row.E86 || 0) + +(row.E88 || 0)
          }


          setDataTable(addSumRow({
            dataTable: results,
            sumColNms: ["TripAmnt", "OthAmnt", "ExpTotal", "E14", "E1028", "E86", "E88", "OthAmnt"],
            sumColTotal: "ContNo"
          }))
          // delete value.data.PCTrns
          // for (const trns of value.data.PCTrns) {

          // }

          // const { SalAmnt, IncAmnt4, NumSts3, DeSSPrct, GrpNm } = value.data
          // const wage = +(SalAmnt || 0) + (IncAmnt4 || 0)
          //  + ((NumSts3 || 0) * 100) + (GrpNm === "TY" ? 100 : 0)
          // const minMaxWage = Math.max(Math.min(wage, 15000), 1650)
          // value.data.DeSSAmnt = minMaxWage * (DeSSPrct || 0) / 100
          setDialogData({
            ...value.data,
            SumInc: +(value.data.SalAmnt || 0) + +(value.data.IncAmnt1 || 0) + +(value.data.IncAmnt2 || 0)
              + +(value.data.IncAmnt3 || 0) + +(value.data.IncAmnt4 || 0) + +(value.data.OthAmnt || 0)
              + +(value.data.IncAmnt5 || 0) + sumExpTotal,
            SumDeduct: +(value.data.DeLoanAmnt || 0) + +(value.data.DeElecAmnt || 0) + +(value.data.DeSecDepAmnt || 0)
              + +(value.data.DeSSAmnt || 0) + +(value.data.DeOthAmnt || 0) + +(value.data.DeEduLoanAmnt || 0)
              + +(value.data.DeTfcFineAmnt || 0) + +(value.data.DeAmnt1 || 0) + +(value.data.DeAmnt2 || 0)
              + +(value.data.DeAmnt3 || 0),
            SumTrip: sumExpTotal,
            OTLSPayAmnt: +(value.data.OTLSPayAmnt || 0),
          })
        }
      })
    } else {
      setDialogData({ ...initSalaryDialogDetail })
      setDataTable([{ id: 0 }])
    }
  }, [dialogOpen, ax, drvId, salDte])

  console.log("dialogData;:", dialogData)
  console.log("dataTable;:", dataTable)
  return (
    <Dialog
      open={dialogOpen}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth='xl'
    >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title="รายละเอียดเงินเดือน"
        onDeleteClick={null}
      />
      <DialogContent>
        <BoxFC pt={2} height={730} width="100%">
          <BoxFR width="100%" sx={{ justifyContent: "space-evenly" }}>
            <Typography variant="h6" ><strong>พนักงานขับรถ:</strong> {dialogData.DrvNm}</Typography>
            <Typography variant="h6"><strong>รอบจ่ายเงิน:</strong> {dayjs(dialogData.SalDte).format("D MMMM YYYY")}</Typography>
          </BoxFR>
          <BoxFR sx={{ justifyContent: "space-evenly", alignItems: "stretch" }}>
            <BoxFC sx={{
              gap: 1, p: 2,
              border: `1px solid ${grey[500]}`,
              borderRadius: 4,
              position: "relative",
            }}>
              <BoxFR sx={{ alignItems: "stretch" }}>
                <BoxFC sx={{ gap: 1 }}>
                  <TextField {...textFieldProps("SalAmnt")} />
                  <TextField {...textFieldProps("IncAmnt1")} />
                  <TextField {...textFieldProps("IncAmnt2")} />
                  <TextField {...textFieldProps("IncAmnt5")} />
                </BoxFC>
                <BoxFC sx={{ gap: 1 }}>
                  <TextField {...textFieldProps("IncAmnt3")} />
                  <TextField {...textFieldProps("IncAmnt4")} />
                  <TextField {...textFieldProps("SumTrip")} label="ค่าเที่ยว+อื่นๆ"
                    value={`${numberFormat(dialogData.SumTrip)}`} />
                  <TextField {...textFieldProps("OthAmnt")} label={`อื่นๆ${dialogData.OthDscp ? `(${dialogData.OthDscp})` : ""}`} />
                </BoxFC>
              </BoxFR>
              <Typography sx={{ alignSelf: "flex-end" }} variant="h6" color={green[800]}>
                <strong>รวมรายรับ : </strong>{numberFormat(dialogData.SumInc)} บาท
              </Typography>
              {/* <Typography >{numberFormat(sumInc)}</Typography> */}
              <Typography variant="body"
                sx={{ position: "absolute", top: -15, left: 17, py: 0, px: 1, bgcolor: "white" }}>รายรับ</Typography>
            </BoxFC>
            <BoxFC sx={{
              gap: 1, p: 2,
              border: `1px solid ${grey[500]}`,
              borderRadius: 4,
              position: "relative",
            }}>
              <BoxFR sx={{ alignItems: "stretch" }}>
                <BoxFC sx={{ gap: 1 }}>
                  <TextField {...textFieldProps("DeSSAmnt")} />
                  <TextField {...textFieldProps("DeSecDepAmnt")} />
                  <TextField {...textFieldProps("DeTfcFineAmnt")} />
                </BoxFC>
                <BoxFC sx={{ gap: 1 }}>
                  <TextField {...textFieldProps("DeAmnt1")} />
                  <TextField {...textFieldProps("DeAmnt2")} />
                  <TextField {...textFieldProps("DeAmnt3")} />
                  <TextField {...textFieldProps("DeOthAmnt")} label={`อื่นๆ${dialogData.DeOthDscp ? `(${dialogData.DeOthDscp})` : ""}`} />
                </BoxFC>

              </BoxFR>
              <Box flex={1}/>
              <Typography sx={{ alignSelf: "flex-end" }} variant="h6" color={red[800]}>
                <strong>รวมเงินหัก : </strong>{numberFormat(dialogData.SumDeduct)} บาท
              </Typography>
              <Typography variant="body"
                sx={{ position: "absolute", top: -15, left: 17, py: 0, px: 1, bgcolor: "white" }}>เงินหัก</Typography>
            </BoxFC>

            <BoxFC sx={{
              gap: 1, p: 2,
              border: `1px solid ${grey[500]}`,
              borderRadius: 4,
              position: "relative",
            }}>
              <TextField {...textFieldProps("SumInc")} label="รวมรายรับ" sx={{ width: 250 }} />
              <TextField {...textFieldProps("SumDeduct")} label="รวมเงินหัก" sx={{ width: 250 }}
                value={`- ${numberFormat(dialogData.SumDeduct)}`} />
              <TextField {...textFieldProps("DrvAdvPay")} sx={{ width: 250 }}
                value={`- ${numberFormat(dialogData.DrvAdvPay)}`} />

              <Box flex={1}/>
              <Typography sx={{ alignSelf: "flex-end" }} variant="h6" color={blue[800]}>
                <strong>คงเหลือ : </strong>{numberFormat(dialogData.SumInc - dialogData.SumDeduct - +(dialogData.DrvAdvPay || 0))} บาท
              </Typography>
              <Typography variant="body"
                sx={{ position: "absolute", top: -15, left: 17, py: 0, px: 1, bgcolor: "white" }}>สรุปยอด</Typography>
            </BoxFC>
          </BoxFR>
          <BoxFR>
            <Typography variant="h6" >รายละเอียดวิ่งงาน</Typography>
            <Box flex={1} />
            <Button variant="contained" size="small" sx={{ width: 200 }} onClick={handlePrint}>
              <PrintRounded sx={{ mr: 1 }} />พิมพ์</Button>
          </BoxFR>
          <Box flex={1} sx={sxSumColorClass} mt={-1}>
            <DataGridCellExpand
              experimentalFeatures={{ rowPinning: true }}
              disableSelectionOnClick
              hideFooter
              rows={dataTable}
              columns={salaryDriverDetailColumns}
              // onCellClick={handleCellClick}
              getRowClassName={getSumColorClassName}
              pinnedRows={{ bottom: [dataTable.find(row => row.id === 0)] }}
            />
          </Box>
        </BoxFC>
      </DialogContent>
      <DialogFooter okText={""}
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={null} />
    </Dialog>
  )
}

export default React.memo(DriverSalaryDetail)